import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import type { NodeKey } from 'lexical';
import { $getNodeByKey } from 'lexical';
import { useCallback } from 'react';

// Type-only: `ImageNode` renders `ImageComponent`, so a runtime import would be circular
import type { ImageNode } from './ImageNode';

/** Edits the image node for `nodeKey` in an editor update; a no-op if it was deleted meanwhile. */
export const useUpdateImage = (nodeKey: NodeKey) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    (mutate: (node: ImageNode) => void) =>
      editor.update(() => {
        const node = $getNodeByKey<ImageNode>(nodeKey);
        if (node) mutate(node);
      }),
    [editor, nodeKey],
  );
};

/** Widest an image may get: the editor's content area. */
export const useMaxImageWidth = () => {
  const [editor] = useLexicalComposerContext();
  return useCallback(() => editor.getRootElement()?.clientWidth ?? Number.POSITIVE_INFINITY, [editor]);
};
